module.exports = __webpack_public_path__ + "static/favicon-fd906414bef706a28205cca5ddd719e7.png";